import { Vue, Component, Prop } from "vue-property-decorator";
import { Mutation, State } from 'vuex-class';
import Icon from './icon';

@Component
export default class LabelWithHelp extends Vue {

  @Prop({default: false}) readonly withIcon!: boolean;
  @Prop({default: ""}) readonly message!: string;
  @Prop({default: "top"}) readonly tooltipPosition: string;

  @State('isHelpEnabled') protected isHelpEnabled: boolean;

  render() {
    return (
      <label class="label label-with-help">
        {this.$slots.default}
        {this.withIcon && [
          ' ',
          <a class={`tooltip ${this.isHelpEnabled ? 'is-tooltip-active' : ''} is-tooltip-multiline is-tooltip-${this.tooltipPosition}`}
            data-tooltip={this.message} style="font-weight: normal">
            <Icon icon="question-circle" class="icon is-small info"/>
          </a>
        ]}
      </label>
    )
  }
}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-802678be/label-with-help.tsx" });